import './ccf-digital-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDigitalIconProps extends SvgIconProps {}
/**
 * component used to display digital icon
 * @param props - CcfDigitalIconProps
 * @example - <CcfDigitalIcon />
 * @returns SVG of digital icon
 */
export function CcfDigitalIcon(props: CcfDigitalIconProps) {
  return (
    <SvgIcon viewBox="0 0 16.026 16" {...props}>
      <path className="a" d="M14.132,8l1.732,3h0a1.2,1.2,0,0,1,0,1.2l-1.848,3.2h0a1.2,1.2,0,0,1-1.04.6H9.28a1.2,1.2,0,0,1-1.04-.6l-1.729-3H3.047a1.2,1.2,0,0,1-1.04-.6L.16,8.6h0a1.2,1.2,0,0,1,0-1.2L2.007,4.2h0a1.2,1.2,0,0,1,1.04-.6H6.511L8.24.6h0A1.2,1.2,0,0,1,9.28,0h3.694a1.2,1.2,0,0,1,1.04.6l1.848,3.2h0a1.2,1.2,0,0,1,0,1.2ZM7.9,4.4,9.513,7.2h3.233l1.616-2.8L12.746,1.6H9.513ZM6.511,10.8,8.128,8,6.511,5.2H3.28L1.661,8,3.28,10.8Zm6.235-2H9.513L7.9,11.6l1.616,2.8h3.234l1.616-2.8Z" transform="translate(0.001)"/>
    </SvgIcon>
  );
}

export default CcfDigitalIcon;
